'use strict';

class PasswordReset {
  constructor($window, $location, userService) {
    this.$window = $window;
    this.$location = $location;
    this.userService = userService;
  }

  $onInit() {
    this.params = this.$location.search();

    this.valid = false;
    this.password = null;
    this.verifyPassword = null;
    this.showExpiredInfo = false;

    this.load();
  }

  load() {
    this.userService.validatePasswordLink(this.params.id, this.params.dt, this.params.key)
      .then(() => {
        this.valid = true;
      });
    this.showExpiredInfo = this.params.expired;
  }

  compare() {
    return this.password !== this.verifyPassword;
  }

  reset() {
    this.userService.resetPassword(this.params.id, this.params.dt, this.params.key, this.password)
      .then(() => {
        this.$window.location.href = '/logg-inn/';
      });
  }
}

PasswordReset.$inject = ['$window', '$location', 'userService'];

const passwordReset = {
  controller: PasswordReset,
  template: `
    <div class="row">
      <div class="large-7 columns">
        <h2>Endre passord</h2>
        <h3 ng-show="$ctrl.showExpiredInfo">Passordet ditt er utløpt, vennligst angi et nytt</h3>
        <form name="passwordForm" ng-submit="$ctrl.reset()" ng-cloak novalidate>
          <fieldset ng-show="$ctrl.valid">
            <div>
              <label for="password">Ønsket passord</label>
              <input type="password" id="password" ng-model="$ctrl.password" minlength="6" name="password" password-validator-register required autofocus />
            </div>

            <div>
              <label for="verifyPassword">Gjenta ønsket passord</label>
              <input type="password" id="verifyPassword" name="verifyPassword" ng-model="$ctrl.verifyPassword" required />
              <span class="error" ng-show="$ctrl.compare()">Passordene stemmer ikke overens</span>
            </div>

            <button type="submit" ng-disabled="passwordForm.$invalid || $ctrl.compare()" class="button">Bytt passord</button>
          </fieldset>
        </form>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('passwordReset', passwordReset)
  .config(($routeProvider) => {
    $routeProvider
      .when('/endre-passord', {
        title: 'Endre passord',
        template: '<password-reset />',
        noSidebar: true,
        noNotification: true,
        secure: false
      });
  });
